import disciplines from 'leverade-disciplines-i18n/i18n/ca'

export default {
  disciplines,

  photo: '{count} foto | {count} fotos',
}



// WEBPACK FOOTER //
// ./src/server/i18n/ca/index.js